import { Directive } from '@angular/core';
import { BusinessLegalProtectionInsuranceMetadata } from 'src/app/_types/lead.types';
import { getBusinessLegalProtectionTypeLabel } from 'src/app/enums/business/business-legal-protection-type.enum';
import { getPaymentFrequencyLabel } from 'src/app/enums/payment-frequency.enum';
import { getBooleanLabel } from 'src/app/helpers/utils';

import { BaseMetadataComponent } from '../../base-metadata.component';

@Directive()
export abstract class BusinessLegalProtectionMetadataComponentAbstract extends BaseMetadataComponent<BusinessLegalProtectionInsuranceMetadata> {
  getBooleanLabel = getBooleanLabel;

  getPaymentFrequencyLabel = getPaymentFrequencyLabel;

  getBusinessLegalProtectionTypeLabel = getBusinessLegalProtectionTypeLabel;

  hasGeneralInfo(data?: BusinessLegalProtectionInsuranceMetadata): boolean {
    if (!data) return false;
    return [
      data.startDate,
      data.contractDuration,
      data.paymentFrequency,
      data.splitPaymentFee,
      data.hasclaimsLastFiveYears,
      data.claims,
      data.totalSalaries,
      data.totalRevenue,
      data.legalProtectionType,
    ].some((v: any) => v !== null && v !== undefined && v !== '');
  }

  isSectionEmpty(section?: Record<string, any> | null): boolean {
    if (!section) return true;
    const values = Object.values(section);
    if (!values.length) return true;
    return !values.some((v) => v !== null && v !== undefined && v !== '');
  }
}
